import styled from "styled-components";
import { BubbleTooltipContainerDefaultBox } from "./bubble-tooltip-container.default.box";

export const BubbleTooltipContainerMrGreenBox = styled(BubbleTooltipContainerDefaultBox)`
    padding-block: 8px 10px;
`;